export enum ThreadEvent {
  /** The `OnThreadStarted` event is emitted when a thread is started. */
  OnThreadStarted = 'OnThreadStarted',
}
